import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { PageTransition } from './PageTransition';

export default function AppShell() {
  const location = useLocation();
  const isHome = location.pathname === '/';
  // /access is a focused, controlled entry moment — keep the nav, drop the footer
  const isAccess = location.pathname === '/access';

  return (
    <div className="app-shell">
      <Navigation />
      <main className="app-main">
        <AnimatePresence mode="wait" initial={false}>
          <PageTransition key={location.pathname}>
            <Outlet />
          </PageTransition>
        </AnimatePresence>
      </main>
      {!isHome && !isAccess && <Footer />}
    </div>
  );
}
